// extracted by mini-css-extract-plugin
export default {"button":"TrashBinWidget_button__6-zAI"};